/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Workbook } from "./Workbook";
export const ListWorkbooksResponse = core.serialization.object({
    data: core.serialization.list(Workbook),
});
